<template>
    <span>
        <Col :span="span">
            <Select :clearable="clearable" v-model="group" :placeholder="tip[0]" @on-clear="clearGroup" @on-change="getUserList">
                <Option v-for="item in groups" :value="item.id" :key="item.id">{{item.name}}</Option>
            </Select>
        </Col>
        <Col :span="span" :offset="offset" :style="{marginLeft:margin}">
            <Select :clearable="clearable" v-model="user" :placeholder="tip[1]" @on-change="setUser" >
                <Option v-for="item in users" :value="item.uid" :key="item.uid">{{item.username}}</Option>
            </Select>
        </Col>
    </span>
</template>

<script>
    import $api from "@/service/index";
    export default {
        props:{
            //是否包含全部
            all : Boolean,
            //
            clearable : Boolean,
            //默认选中的部门id
            groupId:String,
            //默认选中的人uid
            uid:String,
            //span
            span : String,
            //offset,
            offset : String,
            //margin
            margin : String,
            //placeholder
            tip : {
                type : Array,
                default:()=>{return ['请选择部门','请选择人员']}
            },
            //是否要包含选哪官方的选项
            more : {
                type : Boolean,
                default : false,
            }
        },
        data(){
            return {
                //备选项
                group : "",
                user : "",
                groups : [],
                users : [],
                selectList : {}
            };
        },
        created(){
            this.group = this.groupId;
            this.user = this.uid;
            this.getSelectList();
        },
        methods : {
            //获取初始数据
            getSelectList(){
                let _self = this;
                $api.getGroupRelateUser(this.more).then(data=>{
                    for(let i in data){
                        this.selectList[data[i].id] = Object.assign({},data[i]);
                    }
                    let defaultGroupSelect = this.all ? [{"name":"全部","id":"0"}] : [];
                    _self.groups = defaultGroupSelect.concat(data);
                    if( !( !_self.groupId && _self.groupId==="")){
                        let defaultUserSelect = this.all ? [{"uid" : "0","username" : "全部"}] : [];
                        _self.users = defaultUserSelect.concat((_self.selectList[_self.groupId]&&_self.selectList[_self.groupId].user) ? _self.selectList[_self.groupId].user : []);
                    }
                });
            },
            /**
             * 获取二级
             * @param {string} val 选中项value
             */
            getUserList(val){
                let _self = this;
                _self.user = "";
                let defaultUserSelect = this.all ? [{"uid" : "0","username" : "全部"}] : [];
                if(val !== "0" && val !== "" && val){
                    _self.users = defaultUserSelect.concat(_self.selectList[val].user ? _self.selectList[val].user : []);
                }else{
                    _self.users = defaultUserSelect.concat([]);
                }
                this.$emit('refreshData',{'groupId':_self.group?_self.group:"",'uid':""});
            },
            //清除部门
            clearGroup(){
                this.user = "";
                let defaultUserSelect = this.all ? [{"uid" : "0","username" : "全部"}] : [];
                this.users = defaultUserSelect.concat([]);
            },
            //选完人之后
            setUser(val){
                let _self = this;
                this.$emit('refreshData',{'groupId':_self.group?_self.group:"",'uid':_self.user?_self.user:""});
            },
            //获取结果
            getData(){
                let _self = this;
                this.$emit('refreshData',{'groupId':_self.group?_self.group:"",'uid':_self.user?_self.user:""});
            },
        },
        watch : {
            uid(){
                this.getSelectList();
            }
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/groupUserSelect/GroupUserSelect.vue